"use client";
import Image from "next/image";
import Link from "next/link";
import Section from "@/components/Section";
import ProductPage from "@/components/ProductPage";

import Softguide from "./softguide.svg";
import Pulsa from "./pulsa.webp";
import MaxData from "./maxdata.gif";
import EconomicForumDeutschland from "./efd.gif";
import ImageHero from "./partner.jpg";

const partners = [
  {
    name: "Softguide",
    image: Softguide,
    link: "https://www.softguide.de/",
    text: "Ihre Marktübersicht über Standardsoftware, Business Software und Branchenlösungen.",
  },
  {
    name: "Pulsa",
    image: Pulsa,
    link: "https://www.pulsa.de/",
    text: "Spezialist für Etikettendrucker, Bondrucker, Barcodescanner und Datenerfassungssysteme.",
  },
  {
    name: "MaxData",
    image: MaxData,
    link: "/",
    text: "Für uns die unschlagbare Nr.1 in Sachen PC-Komplettsysteme.",
  },
  {
    name: "Economic Forum Deutschland",
    image: EconomicForumDeutschland,
    link: "https://www.economic-forum-deutschland.de/",
    text: "Überparteiliche Plattform zur Förderung der deutschen Wirtschaft.",
  },
];

export default function Partner() {
  return (
    <>
      <ProductPage
        productName="Unsere Partner – SDI Group"
        hero={{
          title: "Unsere Partner",
          subtitle:
            "Gemeinsam mit starken Partnern gestalten wir leistungsstarke Lösungen. Sie sichern Innovation, Qualität und optimale Betreuung – von Technologie bis Support.",
          buttonLeft: {
            title: "Partner werden",
            href: "/kontakt",
          },
          buttonRight: {
            title: "Kontakt aufnehmen",
            href: "/support",
          },
          image: ImageHero,
          imageAlt: "Unsere Partner",
        }}
        highlight={{
          image: ImageHero,
          bullets: [
            <>
              <strong>Softguide</strong> – Marktübersicht über Business Software
              und Branchenlösungen.
            </>,
            <>
              <strong>Pulsa</strong> – Spezialist für Etikettendrucker,
              Bondrucker und Barcodescanner.
            </>,
            <>
              <strong>MaxData</strong> – Die Nr. 1 in Sachen PC-Komplettsysteme.
            </>,
          ],
        }}
        beforeVideo={
          <Section className="bg-white py-4 md:py-6 mt-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
              {/* LINKS: Partnerliste */}
              <div className="flex flex-col gap-6">
                {partners.map((partner, i) => (
                  <Link
                    key={i}
                    href={partner.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex items-start gap-4 p-5 rounded-2xl border border-slate-200 hover:shadow-md hover:-translate-y-1 transition-all"
                  >
                    <div className="shrink-0 flex items-center justify-center h-16 w-24 rounded-full bg-slate-100">
                      <Image
                        src={partner.image}
                        alt={partner.name}
                        width={100}
                        className="object-contain"
                      />
                    </div>

                    <div>
                      <h3 className="text-lg font-semibold text-slate-900">
                        {partner.name}
                      </h3>
                      <p className="mt-1 text-sm text-slate-700 leading-relaxed">
                        {partner.text}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>

              {/* RECHTS: VIDEO statt Bild */}
              <div className="relative overflow-hidden mt-15 rounded-2xl border border-black/10 bg-black shadow-sm h-100">
                <video
                  className="w-full h-full object-cover"
                  controls
                  playsInline
                >
                  <source src="/VideoFürWebseite.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
          </Section>
        }
        faqs={[
          {
            q: "Wie kann ich Partner der SDI Group werden?",
            a: "Nehmen Sie einfach Kontakt mit uns auf – wir freuen uns über Anfragen zu Kooperationen und Partnerschaften und melden uns zeitnah mit weiteren Informationen.",
          },
          {
            q: "Was bieten Ihre Partner an?",
            a: "Unsere Partner decken Bereiche wie Softwareübersichten, Hardwarelösungen, PC-Systeme und Wirtschaftsförderung ab – für ein rundes Gesamtpaket rund um Ihre Geschäftsprozesse.",
          },
          {
            q: "Gibt es Vorteile für SDI-Kunden durch die Partnerschaften?",
            a: "Ja, durch unsere Partnernetzwerke profitieren unsere Kunden von aufeinander abgestimmten Hard- und Softwarelösungen aus einer Hand – weniger Aufwand, mehr Effizienz.",
          },
          {
            q: "In welchen Bereichen suchen Sie neue Partner?",
            a: "Wir sind offen für Kooperationen in den Bereichen Hardware, IT-Dienstleistungen, Softwarevertrieb und Beratung – sprechen Sie uns gerne an, wenn Sie eine Zusammenarbeit anstreben.",
          },
          {
            q: "Sind die Partnerschaften regional oder überregional?",
            a: "Wir arbeiten sowohl mit regionalen als auch überregionalen Partnern zusammen – entscheidend ist eine gemeinsame Ausrichtung auf Qualität und Kundenzufriedenheit.",
          },
          {
            q: "Wie profitieren Partner von der Zusammenarbeit mit der SDI Group?",
            a: "Partner profitieren von unserem langjährigen Know-how, einem etablierten Kundenstamm und der Möglichkeit, gemeinsam maßgeschneiderte Lösungen für Endkunden anzubieten.",
          },
        ]}
        features={[]}
      />
    </>
  );
}
